import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableTeam = Loadable({
  loader: function loader() {
    return import('../Team/Team.jsx');
  },
  loading: ComponentLoading
});
export default LoadableTeam;